import { NgModule } from "@angular/core";
import { MatTableResponsiveDirective } from "./mat-table-response.directive";

@NgModule({
  declarations: [MatTableResponsiveDirective],
  exports: [MatTableResponsiveDirective]
})
export class MatTableResponsiveModule {}
